import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'time',
})
export class TimePipe implements PipeTransform {
	transform(value: number) {
		const hours = Math.floor(value / 3600);
		const minutes = Math.floor((value % 3600) / 60);
		const seconds = Math.floor((value % 3600) % 60);

		const hoursDisplay = hours > 0 ? hours + (hours == 1 ? ' hr, ' : ' hrs, ') : '';
		const minutesDisplay = minutes > 0 ? minutes + (minutes == 1 ? ' min, ' : ' mins, ') : '';
		const secondsDisplay = seconds > 0 ? seconds + (seconds == 1 ? ' sec' : ' secs') : '';

		return hoursDisplay + minutesDisplay + secondsDisplay;
	}
}
